<main class="w-full">
  <label
    class="component-field-textarea group w-full flex flex-row relative pr-[8px] rounded-lg bg-gray-50 cursor-text"
    [class.txt-labeled]="isLabeled"
    [class.txt-tabeled]="isTabeled"
    [class.txt-disabled]="isDisabled"
    [class.txt-readonly]="isReadOnly"
    [class.txt-touched]="isTouched && !isReadOnly"
    [class.txt-error]="hasError"
    [class.txt-valid]="isValidIcon"
    (click)="click()"
  >
    <span [class.w-6]="isLabeled && !isTabeled && !inputComponetHelperIconLeftStyle"></span>

    @if (inputComponetHelperIconLeftStyle) {
    <section class="flex justify-start items-center min-w-[37px] w-[37px] h-[35px]">
      <div [class]="inputComponetHelperIconLeftStyle"></div>
    </section>
    } @if (isLabeled && copy && !isTabeled) {
    <section
      title="Copiar!"
      (click)="copyToClipboard($event)"
      class="ico-copy-labeled cursor-pointer w-6 flex justify-center items-center min-w-6 mt-[14px] opacity-0 group-hover:opacity-100 transition duration-200 ease-in-out z-[2000]"
    >
      <div
        class="txt-icon-copy opacity-100 bg-gray-700 transition duration-200 ease-in-out z-[1000]"
      ></div>
    </section>
    } @if (!isLabeled && !isTabeled) {
    <section class="w-6 flex justify-center items-center min-w-6 mt-[14px]">
      @if (isRequired) {
      <lbca-icon
        name="lucide:asterisk"
        size="small"
        class="transition duration-200 ease-in-out text-primary"
        [class.text-gray-600]="valueToReturn"
      ></lbca-icon>
      }
    </section>
    }

    <section class="grow flex flex-col relative">
      @if (!isTabeled) {
      <p
        class="mt-[10px] text-gray-700 text-sm transition duration-200 ease-in-out"
        [class.text-xs]="isTouched"
      >
        {{ labelValue }}
      </p>
      }

      <textarea
        #inputData
        [disabled]="isDisabled"
        (focus)="focusIn()"
        (blur)="focusOut()"
        (keyup)="inputKeyUpEvent($event)"
        class="peer w-full min-h-[80px] mb-[10px] outline-none text-sm resize-none"
        >{{ fillValue }}</textarea
      >

      <div class="absolute left-0 bottom-0 w-full h-full pointer-events-none">
        <div
          class="absolute left-0 bottom-0 h-[2px] w-0 opacity-0 transition-all duration-300 peer-focus:w-full peer-focus:opacity-100"
          [class.bg-primary]="!hasError"
          [class.bg-error]="hasError"
        ></div>
      </div>
    </section>

    @if (!componentFilling && !isLabeled && !isTabeled && (hasError || isValidIcon)) {
    <section class="w-6 flex justify-center items-center min-w-6 mt-[14px]">
      <div
        class="opacity-100 transition duration-200 ease-in-out"
        [class.bg-error]="hasError"
        [class.bg-primary]="isValidIcon"
      ></div>
    </section>
    } @if (valueToReturn && !isLabeled && !isTabeled && copy) {
    <section
      title="Copiar!"
      (click)="copyToClipboard($event)"
      class="cursor-pointer w-6 flex justify-center items-center min-w-6 mt-[14px]"
    >
      <div class="txt-icon-copy opacity-100 bg-gray-700 transition duration-200 ease-in-out"></div>
    </section>
    } @if (isDisabled) {
    <div class="absolute inset-0 bg-gray-50 cursor-not-allowed rounded-lg"></div>
    }
  </label>

  @if (enableCount) {
  <section class="w-full flex justify-center">
    @if (helperTextValue) {
    <div class="text-gray-700 w-4/5 text-sm">{{ helperTextValue }}</div>
    }
    <div
      class="ml-auto text-right text-sm"
      [class.text-error]="errorCtrl"
      [class.text-gray-700]="!errorCtrl"
    >
      {{ limitFeedback }}
    </div>
  </section>
  }
</main>

<ng-template #templateCopy>
  <div class="text-base text-font flex items-center justify-center show">
    Copiado!
    <lbca-icon name="emoji--happy" class="icon-box ml-[16px]"></lbca-icon>
  </div>
</ng-template>
